import { Button } from "@/components/ui/button";
import { Construction, Instagram } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

export default function EmConstrucao() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-green-100 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center">
        {/* Logo Circular */}
        <div className="mx-auto w-40 h-40 rounded-full overflow-hidden shadow-lg border-4 border-green-200">
          <img src="/camisa-preta.JPG" alt="Brenda Nutricionista" className="w-full h-full object-cover object-top" />
        </div>

        {/* Ícone de Construção Animado */}
        <div className="mt-8 mb-6">
          <Construction className="w-20 h-20 mx-auto text-green-600 animate-bounce" />
        </div>

        {/* Título */}
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Site em Construção 🚧</h1>

        {/* Mensagem */}
        <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-xl mx-auto">
          Em breve, uma nova experiência para cuidar da sua saúde nutricional com ciência e empatia.
        </p>

        {/* Seção de Contato */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Enquanto preparamos nosso novo site, entre em contato:
          </h2>

          <div className="space-y-4">
            {/* Botão WhatsApp */}
            <Button
              onClick={() =>
                window.open(
                  "https://api.whatsapp.com/send/?phone=5511998874081&text&type=phone_number&app_absent=0",
                  "_blank",
                )
              }
              className="w-full bg-green-500 hover:bg-green-600 text-white py-6 text-lg"
            >
              <FaWhatsapp className="mr-2 w-6 h-6" />
              Fale conosco no WhatsApp
            </Button>

            {/* Instagram */}
            <Button
              variant="outline"
              onClick={() => window.open("https://www.instagram.com/brenda.nutricionista/", "_blank")}
              className="w-full border-green-500 text-green-600 hover:bg-green-50 py-6 text-lg"
            >
              <Instagram className="mr-2 w-6 h-6" />
              Siga no Instagram
            </Button>
          </div>

          {/* Email */}
          <p className="mt-6 text-gray-600">📧 contato@brendanutricionista.com.br</p>
        </div>

        {/* Previsão de Lançamento */}
        <p className="text-sm text-gray-500">Previsão de lançamento: Em breve</p>
      </div>
    </div>
  );
}
